__turbopack_context__.v({
  "confirmation": "_0nAc_W_confirmation",
  "divider": "_0nAc_W_divider",
  "note": "_0nAc_W_note",
  "title": "_0nAc_W_title",
});
